import { Link } from "react-router-dom";

/**
 * Minimal footer with links to the hosted legal documents. Site-wide via
 * AppShell. Kept intentionally light — no marketing chrome, just the
 * required legal pointers and a copyright line so no page in the app
 * lives without a link out to /terms and /privacy.
 */
export default function LegalFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-auto border-t border-slate-200 bg-white" data-testid="legal-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 text-xs text-slate-500">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div>© {year} Electable LLC. All rights reserved.</div>
          <nav className="flex items-center gap-4">
            <Link to="/terms" className="hover:text-flag-navy font-semibold" data-testid="footer-terms-link">Terms of Service</Link>
            <Link to="/privacy" className="hover:text-flag-navy font-semibold" data-testid="footer-privacy-link">Privacy Policy</Link>
            <a href="mailto:spencer@electableai.com" className="hover:text-flag-navy font-semibold" data-testid="footer-support-link">Support</a>
          </nav>
        </div>
        <div className="mt-2 text-slate-400" data-testid="footer-party-disclaimer">
          Electable LLC is an independent company. It is not affiliated with, endorsed by, or authorized by the Republican National Committee or any party committee.
        </div>
      </div>
    </footer>
  );
}
